export default __webpack_public_path__ + "static/media/Rhea_01.c552ccb8.png";